import React, { useState, useEffect } from 'react';

export default function MenuSync() {
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [syncing, setSyncing] = useState(false);
  const [syncResult, setSyncResult] = useState(null);

  useEffect(() => {
    fetchPreview();
  }, []);

  async function fetchPreview() {
    try {
      setLoading(true);
      setError(null);
      const response = await fetch('/api/category-sync/preview');
      if (!response.ok) throw new Error('Failed to fetch preview');
      const data = await response.json();
      setPreview(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  async function handleSyncAll() {
    try {
      setSyncing(true);
      setSyncResult(null);
      const response = await fetch('/api/category-sync/sync', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Sync failed');
      setSyncResult(data);
    } catch (err) {
      setSyncResult({ written: 0, failed: [], error: err.message });
    } finally {
      setSyncing(false);
    }
  }

  return (
    <div className="product-sync-container">
      <h2>Menu Sync</h2>
      <p className="subtitle">Sync menus and menu groups into Firestore as Categories</p>

      {error && <div className="error">✕ {error}</div>}
      {loading && <p className="loading">Loading...</p>}

      {!loading && !error && preview && (
        <p>
          This will sync <strong>{preview.menuCount}</strong> menus and{' '}
          <strong>{preview.groupCount}</strong> menu groups into Firestore, overwriting any
          existing documents at those paths.
        </p>
      )}

      <div className="sync-action-bar">
        <button disabled={syncing || loading} onClick={handleSyncAll}>
          {syncing ? 'Syncing...' : 'Sync All to Firestore'}
        </button>
      </div>

      {syncResult && (
        <div className={syncResult.error || syncResult.failed?.length ? 'error' : 'success-message'}>
          {syncResult.error
            ? `Sync failed: ${syncResult.error}`
            : `Wrote ${syncResult.written} document(s), ${syncResult.failed.length} failed`}
          {syncResult.failed && syncResult.failed.length > 0 && (
            <ul>
              {syncResult.failed.map((f) => (
                <li key={f.path}>{f.path}: {f.error}</li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}
